// extracted by mini-css-extract-plugin
export var bodyRow = "_fj-d";
export var cardColumns = "_fj-e";
export var ellipsesOverflow = "_fj-2";
export var flatBottomCorners = "_fj-3";
export var flatTopCorners = "_fj-4";
export var headerActionsDropdown = "_fj-f";
export var headerBottomRow = "_fj-c";
export var headerTopRow = "_fj-b";
export var orderDetailsWrapper = "_fj-0";
export var orderInfoContainer = "_fj-1";
export var productDetails = "_fj-9";
export var productImage = "_fj-5";
export var responsiveTable = "_fj-8";
export var shipmentContainer = "_fj-a";
export var tableBottomLeft = "_fj-6";
export var tableBottomRight = "_fj-7";
export var trackingLink = "_fj-g";